// @flow
import type { MessageObject, MessageParameters } from "../../i18n/types";
import LayoutHintCollection from "../layouthint/LayoutHintCollection";

/**
 * Wrapper around an error message / object
 */
class ErrorModel {
  _id: string;
  _defaultMessage: ?string;
  _parameters: ?MessageParameters;
  _isClientConstraint: boolean;
  _layouthint: LayoutHintCollection;

  /**
   * Contruct
   */
  constructor(
    id: string,
    defaultMessage: ?string,
    parameters: ?MessageParameters,
    isClientConstraint: boolean = false,
    layouthint: LayoutHintCollection = new LayoutHintCollection(),
  ) {
    this._id = id;
    this._parameters = parameters;
    this._defaultMessage = defaultMessage;
    this._isClientConstraint = isClientConstraint;
    this._layouthint = Array.isArray(layouthint)
      ? new LayoutHintCollection(layouthint)
      : layouthint;
  }

  /**
   * Get id of error
   */
  get id(): string {
    return this._id;
  }

  /**
   */
  get defaultMessage(): ?string {
    return this._defaultMessage;
  }

  /**
   */
  get parameters(): ?MessageParameters {
    return this._parameters;
  }

  /**
   */
  get isClientConstraint(): boolean {
    return this._isClientConstraint || false;
  }

  /**
   */
  get layouthint(): LayoutHintCollection {
    return this._layouthint;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return this.id === "Constraint.Mandatory";
  }

  /**
   * Returns a message object from the error
   */
  getMessage(): MessageObject {
    return {
      id: this.id,
      defaultMessage: this.defaultMessage ?? "",
      parameters: this.parameters ?? {},
    };
  }
}

export default ErrorModel;
